import { RootState } from '@reducers';

export const selectCancerPolicyDetails = (state: RootState) => state.userDashboardRouteReducer.policyDetailsReducer.cancerPolicyDetailsReducer;
